import { Overlay, Popover, Breadcrumb } from 'react-bootstrap';
import { useState, useRef } from "react";
import { Link } from 'react-router-dom';
import '../App.css';
import HelpButton from "./HelpButton";

function Mansion() {

  const [showFrontPopover, setShowFrontPopover] = useState(false);
  const [FrontPopoverText, setFrontPopoverText] = useState('');
  const FrontRef = useRef(null);

  const handleFrontClick = () => {
  setFrontPopoverText("열려있다");
  setShowFrontPopover(true);
  setTimeout(() => setShowFrontPopover(false), 2000);
};

  const [showIntercomPopover, setShowIntercomPopover] = useState(false);
  const [IntercomPopoverText, setIntercomPopoverText] = useState('');
  const IntercomRef = useRef(null);

  const handleIntercomClick = () => {
  setIntercomPopoverText("작동하지 않는다");
  setShowIntercomPopover(true);
  setTimeout(() => setShowIntercomPopover(false), 2000);
};

  return (
    
      <div className="container mt-4 position-relative" style={{ height: '100vh' }}>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center">
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={(e) => {
            e.preventDefault();  // 링크 기본동작 막기
            alert('아직 길드장님을 만나지 못했다');
          }}
          href="#" // href 있어야 커서 포인터 모양 유지됨
          style={{ cursor: 'pointer' }} // 클릭 가능하다는 시각적 표시
        >
          집
        </Breadcrumb.Item>
        <Breadcrumb.Item active>저택</Breadcrumb.Item>
      </Breadcrumb>
      {/* 오른쪽 상단 버튼 */}
      <HelpButton />
      </div>

      {/* 수평선 */}
      <hr className="border border-dark-subtle border-2 opacity-100" />

      {/* 설명 */}
      <div className="text-start">
        <p>고요하다</p>
      </div>

        <div
      className="d-flex justify-content-center align-content-center" 
        style={{height: 'calc(100vh - 200px)',
        alignItems: 'center',
        gap: '20px',
        marginTop: '-10vh',
         }}>
          <div className="d-flex flex-row align-items-center" style={{ gap: '0px' }}>
        <button
          ref={FrontRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleFrontClick}
          style={{
            width: '30vw',
            height: '40vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0'
          }}
          >현관문</button>

          <Link to="/inside"
          className="btn btn-dark"
          style={{
            width: '1vw',
            height: '40vh',
            backgroundColor: 'black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopLeftRadius: '0',
            borderBottomLeftRadius: '0',
            padding: 0,
            textDecoration: 'none'
          }}aria-label="그림자 영역 클릭 시 이동"
          >
          <span style={{ width: '100%', height: '100%' }}></span>
        </Link>
          </div>
          
          <button
          ref={IntercomRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleIntercomClick}
          style={{
            width: '5vw',
            height: '10vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '70%',
          }}
          >인터폰</button>

</div>


        {FrontRef.current && (
          <Overlay target={FrontRef.current} show={showFrontPopover} placement="top">
            {(props) => (
              <Popover {...props}>
                <Popover.Body>{FrontPopoverText}</Popover.Body>
              </Popover>
            )}
          </Overlay>
        )}


        {IntercomRef.current && (
          <Overlay target={IntercomRef.current} show={showIntercomPopover} placement="top">
            {(props) => (
              <Popover {...props}>
                <Popover.Body>{IntercomPopoverText}</Popover.Body>
              </Popover>
            )}
          </Overlay>
        )}

</div>
    );
}

export default Mansion;
